import styled from '@emotion/styled';
import { Box } from '@lightspeed/flame/Core';
import { Modal, ModalBody, ModalFooter } from '@lightspeed/flame/Modal';

export const StyledModal = styled(Modal)`
  width: 50%;
  max-width: 600px;
  @media screen and (max-width: 992px) {
    max-width: 80%;
  }
`;

export const StyledModalBody = styled(ModalBody)`
  padding: 0px !important;
  overflow: auto;
  margin-bottom: -1px;
`;

export const StyledModalFooter = styled(ModalFooter)`
  z-index: 1;
`;

export const StyledItemDescription = styled(Box)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
